import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] p-4 text-sm text-gray-300">
      <div className="container mx-auto flex flex-col items-center justify-between gap-2 sm:flex-row">
        <span>
          &copy; Copyright {new Date().getFullYear()}, Les Productions Sutton
          Encore
        </span>
        <Link to="/privacy-policy" className="hover:text-white">
          Politique de vie Privée
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
